/* eslint-disable no-use-before-define */

/* eslint-disable no-unused-vars */

/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import { Animated, Platform, StyleProp, StyleSheet, TextStyle, View, ViewStyle } from "react-native";
import SVG_Svg, {
  ClipPath as SVG_ClipPath,
  Defs,
  G as SVG_G,
  GProps,
  Path as SVG_Path,
  PathProps,
} from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: desc */

/***/

const ClipPath = Animated.createAnimatedComponent(SVG_ClipPath);
const Path = Animated.createAnimatedComponent<
  React.ComponentClass<
    PathProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_Path);
const G = Animated.createAnimatedComponent<
  React.ComponentClass<
    GProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_G);
const Svg = Animated.createAnimatedComponent(SVG_Svg);

/*
 * -------------------------------------------------------------------------
 *
 *  /$$$$$$                                /$$$$$$$  /$$
 * |_  $$_/                               | $$__  $$| $$
 *   | $$   /$$$$$$/$$$$   /$$$$$$        | $$  \ $$| $$ /$$   /$$  /$$$$$$
 *   | $$  | $$_  $$_  $$ /$$__  $$       | $$$$$$$ | $$| $$  | $$ /$$__  $$
 *   | $$  | $$ \ $$ \ $$| $$  \ $$       | $$__  $$| $$| $$  | $$| $$$$$$$$
 *   | $$  | $$ | $$ | $$| $$  | $$       | $$  \ $$| $$| $$  | $$| $$_____/
 *  /$$$$$$| $$ | $$ | $$| $$$$$$$/  /$$  | $$$$$$$/| $$|  $$$$$$/|  $$$$$$$
 * |______/|__/ |__/ |__/| $$____/  |__/  |_______/ |__/ \______/  \_______/
 *                       | $$
 *                       | $$
 *                       |__/
 *
 * -------------------------------------------------------------------------
 *
 * ORIGINAL SVG
 * ---------------------------------
 * <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none"> <desc id="IMP.BLUE">{"#FacebookIcon":{"type":"SELECTOR","constraint":"xMinYMin meet","width":25,"height":25},"#Group":{"type":"SELECTOR","constraint":"none","width":25,"height":25},"#Vector":{"type":"SELECTOR","constraint":"none","width":25,"height":25},"transforms":{}}</desc>
 * <g id="FacebookIcon" clip-path="url(#clip0)">
 * <g id="Group">
 * <g id="Group_2">
 * <path id="Vector" d="M22.9167 0H2.08335C0.91665 0 0 0.91665 0 2.08335V22.9167C0 24.0834 0.91665 25 2.08335 25H11.6667H16.6667H22.9167C24.0834 25 25 24.0833 25 22.9167V2.08335C25 0.91665 24.0833 0 22.9167 0ZM12.5 24.1667V15.8333H9.16665V12.5H12.5V9.58335C12.5 7.20835 14.3334 5.20835 16.6667 5H20.4167V8.33335H17.0833C16.375 8.33335 15.8333 8.875 15.8333 9.58335V12.5H20V15.8333H15.8333V24.1667H12.5V24.1667ZM24.1667 22.9167C24.1667 23.625 23.625 24.1667 22.9167 24.1667H16.6667V16.6667H20.8333V11.6667H16.6667V9.5833C16.6667 9.3333 16.8333 9.16665 17.0833 9.16665H21.25V4.16665H16.625C13.8334 4.41665 11.6667 6.79165 11.6667 9.5833V11.6667H8.3333V16.6667H11.6667V24.1667H2.08335C1.375 24.1667 0.83335 23.625 0.83335 22.9167V2.08335C0.83335 1.375 1.375 0.83335 2.08335 0.83335H22.9167C23.625 0.83335 24.1667 1.375 24.1667 2.08335V22.9167H24.1667Z" fill="black"/>
 * </g>
 * </g>
 * </g>
 * <defs>
 * <clipPath id="clip0">
 * <rect width="25" height="25" fill="white"/>
 * </clipPath>
 * </defs>
 * </svg>
 *
 * ---------------------------------
 *
 * CONFIGURATION
 * ---------------------------------
 * {
 * 	"#FacebookIcon": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 25,
 * 		"height": 25
 * 	},
 * 	"#Group": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 25,
 * 		"height": 25
 * 	},
 * 	"#Vector": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 25,
 * 		"height": 25
 * 	},
 * 	"transforms": {}
 * }
 * ---------------------------------
 *
 * DESCRIPTION
 * ---------------------------------
 * No description provided!
 * ---------------------------------
 */

/** Component Properties Interface */
export type tProps = {
  style?: tStyle;
  svgStyle?: tStyle;
  debug?: boolean;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  onAnimationComplete?: () => void;
};
/***/

/***/

export type tStyle = StyleProp<ViewStyle>;
export type tTextStyle = StyleProp<TextStyle>;
/** Convenience for prop insertion from ast (no-color-literals/no-inline-styles) */

/* eslint-disable react-native/no-color-literals */

/* eslint-disable react-native/no-inline-styles */

/** Local Styles */

const kLocalStyles = StyleSheet.create({
  kOverlay: {
    left: 0,
    position: "absolute",
    top: 0,
  },
});
/***/

/***/

/**
 * Auto-Generated Imp.Blue Component based on your design!
 * @param {tProps} props Developer interface to the component!
 * @returns {JSX.Element} JSX
 *
 * Description --
 * No description provided!
 */

export const FacebookIcon = (props: {
  style?: tStyle;
  svgStyle?: tStyle;
  debug?: boolean;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  onAnimationComplete?: () => void;
}): JSX.Element => {
  const {
    style = {
      width: 25,
      height: 25,
    },
    svgStyle = {
      width: "100%",
      height: "100%",
    },
    svgRef,
  } = props;
  /** Component Internal State */

  /** Component Internal Functions */

  /** Custom React-Hooks */

  /**
   * Custom hook to emulate onLayout events
   * (For use in web env only!)
   */

  /** End Custom React-Hooks */

  /** Component Render (Javascript-React Markup) */

  if (Platform.OS === "web") {
    return (
      <View style={style}>
        <Svg
          fill="none"
          id="svg_root"
          ref={svgRef}
          {...props}
          style={svgStyle}
          preserveAspectRatio="xMinYMin meet"
          viewBox="0 0 25 25"
        >
          <G id="FacebookIcon" clipPath="url(#clip0)">
            <Svg preserveAspectRatio="none" viewBox="0 0 25 25">
              <G id="Group">
                <G id="Group_2">
                  <Svg preserveAspectRatio="none" viewBox="0 0 25 25">
                    <Path
                      id="Vector"
                      d="M22.9167 0H2.08335C0.91665 0 0 0.91665 0 2.08335V22.9167C0 24.0834 0.91665 25 2.08335 25H11.6667H16.6667H22.9167C24.0834 25 25 24.0833 25 22.9167V2.08335C25 0.91665 24.0833 0 22.9167 0ZM12.5 24.1667V15.8333H9.16665V12.5H12.5V9.58335C12.5 7.20835 14.3334 5.20835 16.6667 5H20.4167V8.33335H17.0833C16.375 8.33335 15.8333 8.875 15.8333 9.58335V12.5H20V15.8333H15.8333V24.1667H12.5V24.1667ZM24.1667 22.9167C24.1667 23.625 23.625 24.1667 22.9167 24.1667H16.6667V16.6667H20.8333V11.6667H16.6667V9.5833C16.6667 9.3333 16.8333 9.16665 17.0833 9.16665H21.25V4.16665H16.625C13.8334 4.41665 11.6667 6.79165 11.6667 9.5833V11.6667H8.3333V16.6667H11.6667V24.1667H2.08335C1.375 24.1667 0.83335 23.625 0.83335 22.9167V2.08335C0.83335 1.375 1.375 0.83335 2.08335 0.83335H22.9167C23.625 0.83335 24.1667 1.375 24.1667 2.08335V22.9167H24.1667Z"
                      fill="black"
                      strokeWidth="1"
                      vectorEffect="non-scaling-stroke"
                    />
                  </Svg>
                </G>
              </G>
            </Svg>
          </G>
          <Defs>
            <ClipPath id="clip0">
              <Path
                fill="white"
                id="clip0_elem0"
                d="M0 0 H25 a0,0 0 0 1 0,0 V25 a0,0 0 0 1 -0,0 H0 a0,0 0 0 1 -0,-0 V0 a0,0 0 0 1 0,-0z"
                strokeWidth="1"
                vectorEffect="non-scaling-stroke"
              />
            </ClipPath>
          </Defs>
        </Svg>
      </View>
    );
  }

  return (
    <View style={style}>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 25 25"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          id="Vector"
          d="M22.9167 0H2.08335C0.91665 0 0 0.91665 0 2.08335V22.9167C0 24.0834 0.91665 25 2.08335 25H11.6667H16.6667H22.9167C24.0834 25 25 24.0833 25 22.9167V2.08335C25 0.91665 24.0833 0 22.9167 0ZM12.5 24.1667V15.8333H9.16665V12.5H12.5V9.58335C12.5 7.20835 14.3334 5.20835 16.6667 5H20.4167V8.33335H17.0833C16.375 8.33335 15.8333 8.875 15.8333 9.58335V12.5H20V15.8333H15.8333V24.1667H12.5V24.1667ZM24.1667 22.9167C24.1667 23.625 23.625 24.1667 22.9167 24.1667H16.6667V16.6667H20.8333V11.6667H16.6667V9.5833C16.6667 9.3333 16.8333 9.16665 17.0833 9.16665H21.25V4.16665H16.625C13.8334 4.41665 11.6667 6.79165 11.6667 9.5833V11.6667H8.3333V16.6667H11.6667V24.1667H2.08335C1.375 24.1667 0.83335 23.625 0.83335 22.9167V2.08335C0.83335 1.375 1.375 0.83335 2.08335 0.83335H22.9167C23.625 0.83335 24.1667 1.375 24.1667 2.08335V22.9167H24.1667Z"
          fill="black"
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
        <Defs>
          <ClipPath id="clip0">
            <Path
              fill="white"
              id="clip0_elem0"
              d="M0 0 H25 a0,0 0 0 1 0,0 V25 a0,0 0 0 1 -0,0 H0 a0,0 0 0 1 -0,-0 V0 a0,0 0 0 1 0,-0z"
              strokeWidth="1"
              vectorEffect="non-scaling-stroke"
            />
          </ClipPath>
        </Defs>
      </Svg>
    </View>
  );
};
/***/

export default React.memo(FacebookIcon);
